import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CustomToastrService } from '../ngx-toastr/custom-toastr.service';
import {
  CLOSE,
  EMPTY_STRING,
  ERROR,
  FAILED,
  REDIRECT_FIELD_DATA,
  SUCCESS,
  TOASTER_SUCCESS,
  isServerWordedImportError,
} from '../constants';
import { firstValueFrom, Observable, of, Subscription } from 'rxjs';
import { Store } from '@ngxs/store';
import {
  fileUploadEntityType,
  FileUploadInput,
  fileUploadType,
  importInput,
} from '../../../awsAppSync/API';
import { FileUploadService } from '../../core/services/file-upload.service';
import {
  BulkImportStatus,
  ImportService,
} from '../../core/services/import.service';
import { AuthenticateUserState } from '../../core/store/authenticate-user.state';
import { ImportInspectionDataService } from '../../core/services/import-inspection-data.service';
import { Router } from '@angular/router';
import { PopupDialogService } from '../popup-dialog/popup-dialog.service';
@Component({
  selector: 'app-file-upload-popup',
  templateUrl: './file-upload-popup.component.html',
  styleUrl: './file-upload-popup.component.css',
})
export class FileUploadPopupComponent implements OnInit {
  surveyName?: string;
  surveyId?: string;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  files: File[] = [];
  importStatusSubscription: Subscription | undefined;
  syrcUserId: string | null = null;
  userId$: Observable<string | null> = of(null);
  importMessage = EMPTY_STRING;
  isLoading = false;

  constructor(
    public dialogRef: MatDialogRef<FileUploadPopupComponent>,
    private toastr: CustomToastrService,
    private store: Store,
    private fileUploadService: FileUploadService,
    private importService: ImportService,
    private importInspectionData: ImportInspectionDataService,
    private router: Router,
    private popupDialogService: PopupDialogService,
    @Inject(MAT_DIALOG_DATA)
    public data: { surveyName: string; surveyId: string },
  ) {
    this.surveyName = data.surveyName;
    this.surveyId = data.surveyId;
    this.userId$ = this.store.select(AuthenticateUserState.getSyrcUserId);
  }

  ngOnInit(): void {
    this.userId$.subscribe((userId) => {
      this.syrcUserId = userId ?? '';
    });
  }

  triggerFileInput(): void {
    this.fileInput.nativeElement.click();
  }
  onFileDropped(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer && event.dataTransfer.files) {
      this.addFiles(event.dataTransfer.files);
    }
  }
  onFileInputChange(event: any) {
    const files: FileList = event.target.files;
    this.addFiles(files);
  }
  addFiles(files: FileList) {
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < files.length; i++) {
      this.files.push(files[i]);
    }
  }
  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }
  showDialog = true;
  openDialog() {
    this.showDialog = true;
  }
  closeDialog() {
    this.showDialog = false;
    this.dialogRef.close();
  }
  onUpload() {
    this.isLoading = true;
    this.files.forEach(async (file) => {
      const fileExtension = file.name.match(/\.[0-9a-z]+$/i)?.[0].substring(1);
      if (fileExtension != 'mtx') {
        this.toastr.showError(
          'Invalid file format. Please upload file of .mtx format.',
          ERROR,
        );
        this.dialogRef.close();
      } else {
        const fileName = file.name.replace(/\s+/g, '_');
        console.log('File name -- ', fileName);
        const primaryCompanyId = await firstValueFrom(
          this.store.select(AuthenticateUserState.getSyrcPrimaryCompanyId),
        );
        if (primaryCompanyId) {
          const _fileInputData: FileUploadInput = {
            filename: fileName,
            entityType: fileUploadEntityType.PrimaryCompany,
            entityTypeId: primaryCompanyId + '/Survey',
            fileUploadType: fileUploadType.Import,
          };
          console.log('input ---- ', _fileInputData);
          const _getPresignedURL =
            await this.importService.uploadExcelFile(_fileInputData);
          console.log('Url ---- ', _getPresignedURL);
          const response = await this.fileUploadService.uploadToS3(
            String(_getPresignedURL?.presignedURL),
            file,
          );
          console.log('Upload response ---- ', response);
          if (this.syrcUserId) {
            this.importStatusSubscription = this.importService
              .executeImportSubscription(this.syrcUserId)
              .subscribe({
                next: (data: BulkImportStatus) => {
                  this.importMessage = data.importMessage;
                  this.importInspectionData.errorCode = data.errorCode ?? null;
                  if (data.status === 'Error') {
                    this.importInspectionData.invalidFileUrl =
                      data.fileURL ?? '';
                    this.isLoading = false;
                    this.toastr.showError(
                      isServerWordedImportError(data.errorCode)
                        ? data.importMessage
                        : 'Uploaded File is invalid',
                      ERROR,
                    );
                    this.popupDialogService.openDialog(
                      'File Upload Failed',
                      data.importMessage,
                      FAILED,
                      CLOSE,
                      () => this.router.navigate([REDIRECT_FIELD_DATA]),
                      false,
                      '',
                      false,
                      '',
                      data.fileURL,
                    );
                    this.dialogRef.close();
                    this.importStatusSubscription?.unsubscribe();
                  } else if (data.status === 'Success') {
                    this.isLoading = false;
                    if (data.fileURL) {
                      this.importInspectionData.invalidFileUrl =
                        data.fileURL ?? '';
                      this.toastr.showSuccess(
                        'File Imported with partial success',
                        TOASTER_SUCCESS,
                      );
                      this.popupDialogService.openDialog(
                        'Partial Success',
                        data.importMessage,
                        FAILED,
                        CLOSE,
                        () => this.router.navigate([REDIRECT_FIELD_DATA]),
                        false,
                        '',
                        false,
                        '',
                        data.fileURL,
                      );
                    } else {
                      this.toastr.showSuccess(
                        'File Imported Successfully!',
                        TOASTER_SUCCESS,
                      );
                      this.popupDialogService.openDialog(
                        'File Imported Successfully!',
                        'The file has been Successfully imported to the system.',
                        SUCCESS,
                        CLOSE,
                      );
                    }
                    this.dialogRef.close();
                    this.fileUploadService.setIsFileUploadPopUpShown(false);
                    this.importStatusSubscription?.unsubscribe();
                  }
                  this.showDialog = false;
                },
                error: (err: any) => {
                  console.error('Subscription error:', err);
                  this.importStatusSubscription?.unsubscribe();
                },
              });
          }
          const _input: importInput = {
            fileURL: _getPresignedURL?.fileURL ?? '',
            entityType: 'SurveyJson',
            entityValue: JSON.stringify({
              primaryCompanyId: primaryCompanyId,
              surveyId: this.surveyId,
            }),
          };
          this.importService.bulkImport(_input);
          this.importInspectionData.isFreshRoute = false;
        }
      }
    });
  }
}
